module.exports = __webpack_public_path__ + "resources/1.0.25/media/logo-qobuz-large.25427bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/logo-qobuz-large.png
// module id = 948
// module chunks = 0